// MealPreparationSection.js
import React from 'react';
import { Phone } from 'lucide-react';
import mealPreparationImage from '../assets/meal-preparation-image.jpg';

const MealPreparationSection = () => {
  return (
    <section className="py-16 px-6 md:px-12 lg:px-24 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          
          {/* Left Image */}
          <div>
            <img 
              src={mealPreparationImage} 
              alt="Caregiver preparing meal with elderly woman" 
              className="w-full h-auto rounded-2xl shadow-lg object-cover"
            />
          </div>

          {/* Right Content */}
          <div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              From Meal Preparation to Personal Care
            </h2>
            
            <div className="space-y-4 text-gray-700 font-light leading-relaxed mb-8">
              <p>
                Nutrition plays a vital role in overall health, especially for seniors. Our compassionate caregivers are skilled in meal planning and preparation for diets that accommodate individual preferences, dietary restrictions, and health needs. Whether it's a low-sodium diet, diabetic-friendly meals, or soft food options, we tailor each plan to support our clients' wellness goals.
              </p>
              
              <p>
                For those who have difficulty feeding themselves due to age, illness, or disability, we provide gentle, respectful assistance to ensure they get the nourishment they need without stress or frustration.
              </p>
              
              <p>
                From grocery planning and meal prep to assistance at 20 meals, we're here to make every mealtime safe, comfortable, and enjoyable—because good food is an important part of living well.
              </p>
            </div>
            
            <a 
              href="tel:+61269272706"
              className="inline-flex items-center gap-2 bg-[#E85D2C] hover:bg-[#d54d1f] text-white font-medium px-6 py-3 rounded-full transition-colors"
            >
              <Phone size={20} />
              CALL: (02) 6927 2706
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MealPreparationSection;
